import { Button } from 'components/common'
import { ICellRendererParams } from '@ag-grid-community/core'
import { useNavigate } from 'react-router-dom'
import { PAGE_UPDATE_AGGREGATOR } from 'utils/constants'

type ActionCellRendererProps = {
  params: ICellRendererParams
  isEditor: boolean
  getAggregatorToDelete: (params: ICellRendererParams) => void
}

const ActionCellRenderer = ({
  params,
  isEditor,
  getAggregatorToDelete,
}: ActionCellRendererProps) => {
  const navigate = useNavigate()

  const handleEditAggregator = (aggregatorId: string) => {
    navigate(`${PAGE_UPDATE_AGGREGATOR.path}/${aggregatorId}`)
    return
  }

  return !isEditor ? (
    <></>
  ) : (
    <div className="flex h-full items-center justify-center gap-3">
      <Button
        size="small"
        variant="outline"
        className="w-20"
        buttonText="Edit"
        type="button"
        onClick={() => handleEditAggregator(params.data._id)}
      />

      <Button
        size="small"
        className="w-20"
        buttonText="Delete"
        type="button"
        onClick={() => getAggregatorToDelete(params)}
      />
    </div>
  )
}

export default ActionCellRenderer
